module.exports = __webpack_public_path__ + "static/media/menu.4429db1e.svg";